import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ConfigService } from '../config/config.service';
import {
  UserAccessProfile,
  UserProfileUpdate,
  normalizeUserAccessProfile,
} from './user-access.model';

@Injectable({ providedIn: 'root' })
export class UserAccessApiService {
  private readonly http = inject(HttpClient);
  private readonly configService = inject(ConfigService);

  getMe(): Observable<UserAccessProfile> {
    return this.http
      .get<UserAccessProfile>(`${this.configService.getEnv('baseUrlUsers')}/me`)
      .pipe(map(normalizeUserAccessProfile));
  }

  syncProfile(profile: UserProfileUpdate): Observable<UserAccessProfile> {
    return this.http
      .put<UserAccessProfile>(`${this.configService.getEnv('baseUrlUsers')}/me/profile`, profile)
      .pipe(map(normalizeUserAccessProfile));
  }
}
